import { render, staticRenderFns } from "./CloneCar.vue?vue&type=template&id=22b461a5&"
import script from "./CloneCar.vue?vue&type=script&lang=js&"
export * from "./CloneCar.vue?vue&type=script&lang=js&"
import style0 from "./CloneCar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports